import api from '@/api'
import resource from '@/services/resource'
import searchable from '@/services/searchable'
import appConfig from './../config/app'

/**
 * ===================================================
 * Company
 * ===================================================
 */
export default {
  namespaced: true,
  baseUrl: appConfig.services.finance.baseURl,
  url: 'api/company',
  ...api,
  ...resource,
  ...searchable
}
